import React from "react"
import MetaComponent from "./Meta"
import metaFactory from "./meta.factory"

export { default as PageMetaData } from "./meta.query"

export const Meta = props => {
  const { base, page, staticTitle, schemaMarkup, hubSpotObj } = props
  const componentProps = { ...metaFactory.transform(base, page, staticTitle), hubSpotObj }
  return <MetaComponent {...componentProps} schemaMarkup={schemaMarkup} />
}
